import { render, staticRenderFns } from "./UserFeedbackMode.vue?vue&type=template&id=5bc7ae9a&scoped=true&"
import script from "./UserFeedbackMode.vue?vue&type=script&lang=js&"
export * from "./UserFeedbackMode.vue?vue&type=script&lang=js&"
import style0 from "./UserFeedbackMode.vue?vue&type=style&index=0&id=5bc7ae9a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc7ae9a",
  null
  
)

export default component.exports